import React from 'react';
import { Stack } from '../../../atoms/stack/Stack';
import { Typography } from '../../../atoms/typography/Typography';
import { LinkButton } from '../../../atoms/linkButton/LinkButton';

const ArticleImageSection = ({ data, t }) => {
  // const [email, setEmail] = useState('');
  // const handleInputChange = (e) => {
  //   setEmail(e.target.value);
  // };

  if (data.articleImg && data?.isBottomSection) {
    return null;
  }

  if (!data.articleImg && !data?.isBottomSection) {
    return null;
  }

  return (
    <div className="w-full flex flex-col xl:flex-row justify-between gap-5">
      {!data?.isBottomSection && data.articleImg && (
        <Stack className="w-fit self-center">
          {data.articleImg && (
            <img
              className="rounded-lg w-auto object-contain max-h-[450px] flex self-center"
              src={data.articleImg}
              alt={data.title}
            />
          )}
          <Typography fontVariant="sm" className="h-6 w-fit">
            {data.articleImgCaption}
          </Typography>
        </Stack>
      )}

      <div className="flex flex-1 flex-col sm:flex-row xl:flex-col gap-5 xl:pb-7">
        <Stack className="flex-1 bg-primary-50 gap-5 rounded-2xl p-5 justify-center items-center">
          {data?.categoryGuideUrl && (
            <>
              <Typography as="h2" fontVariant="md" className="font-normal">
                {t('blog.guideStartQuestion')}{' '}
              </Typography>
              <LinkButton
                href={data?.categoryGuideUrl}
                label={t('guideHome.startGuide')}
                className="bg-primary-500"
              />
            </>
          )}
        </Stack>
        {/*
        <Stack className="flex-1 bg-primary-50 rounded-2xl p-5 justify-center items-center">
          <Typography as={'h2'} fontVariant={'md'} className={'font-medium'}>
            TOD: Ska detta ens vara med? Vill du få mail när vi publicerar nya
            artiklar?
          </Typography>
          <Typography fontVariant={'sm'} className={'font-normal'}>
            Signa upp dig för här
          </Typography>
          <div class="relative my-3">
            <input
              id="email"
              type="text"
              value={email}
              placeholder="E-post"
              onChange={handleInputChange}
              className={`border bg-white border-gray-300 rounded-md h-14 px-3 py-2 pr-24 w-full focus:outline-none`}
            />
            <div className="absolute top-0 right-0 bottom-0 flex items-center w-24 justify-center">
              <button
                onClick={() => {}}
                className="rounded-[40px] px-4 py-2 global-hover text-clamp-sm font-medium text-primary-500 border border-customGray-300"
              >
                Skicka
              </button>
            </div>
          </div>
        </Stack>
        */}
      </div>
    </div>
  );
};

export default ArticleImageSection;
